import "core-js/modules/es.object.to-string";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { tabulation } from "@/mixins/index";
import addloadName from "./components/addLoadPross";
import { getLoadData, deleLoadData, updataLoadDataReturn } from "@/api/dataAll/loadPross";
export default {
  name: "loadProcssName",
  components: {
    addloadName: addloadName
  },
  mixins: [tabulation],
  data: function data() {
    return {
      num: "1",
      searchData: {
        page: 1
      },
      tableData: [],
      addCdtconversion: false,
      total: 0,
      page: 1,
      show: false,
      adPlacementSingleChoice: true
    };
  },
  created: function created() {},
  methods: {
    searchClick: function searchClick() {
      var _this = this;

      var searchData = JSON.parse(JSON.stringify(this.searchData));
      searchData.ad_placement = searchData.ad_placement == 'valuets' ? [''] : searchData.ad_placement;
      this.reqLoading = true;
      getLoadData(searchData).then(function (res) {
        if (res.status == 200) {
          var list = ['game', 'platform', 'channel', 'pkg', 'ad_channel', 'ad_placement'];
          _this.tableData = res.data.data.length ? _this.$utils.dataConversion(res.data.data, list) : [];
          _this.total = res.data.total / 10 * 12;
        }
      }).finally(function () {
        _this.reqLoading = false;
      });
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.searchData.page = val;
      this.searchClick();
    },
    handleSource: function handleSource(row) {
      var _this2 = this;

      var data = {
        game_id: this.rawData.game_id,
        special_product_id: row.product_id,
        id: row.id
      };
      updataLoadDataReturn(data).then(function (res) {
        if (res.status == 200) {
          _this2.$refs.addCdtconversion.init(_objectSpread(_objectSpread({}, res.data), data));
        }
      });
    },
    handleDelete: function handleDelete(row) {
      var _this3 = this;

      this.$confirm(this.$t('confirmDeleteData'), this.$t('tip'), {
        confirmButtonText: this.$t('confirm'),
        cancelButtonText: this.$t('cancel'),
        type: "warning"
      }).then( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var data;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                data = {
                  special_product_id: row.product_id,
                  id: row.id
                };
                deleLoadData(data).then(function (res) {
                  _this3.searchData.page = 1;

                  _this3.searchClick();

                  _this3.$message({
                    type: "success",
                    message: res.message
                  });
                });

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      })));
    }
  }
};